<template>
  <div>
    <!-- <router-link
      :to="{
        name: 'industrial_admin_branch_tank_report',
        query: { branchId: data.branchID },
      }"
    >
      <button class="outline">View Tank Details</button>
    </router-link> -->

    <router-link
      :to="{
        name: 'IndustrialBranchDashboard',
        query: {
          branchId: data.branchID,
          companyId: this.$route.query.companyID
            ? this.$route.query.companyID
            : data.companyId,
        },
      }"
    >
      <button>{{ $t("text.clickButtons.toDashboard") }}</button>
    </router-link>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },

  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
  },
};
</script>

<style scoped>
button {
  background-color: #370f70;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
}

.outline {
  background-color: transparent;
  border: 1px solid #370f70;
  color: #370f70;
}
</style>
